module.exports = __webpack_public_path__ + "static/media/html5-plain.377e176b.svg";